<template>
  <div id="ww">
    <!-- NAVIGATION -->
    <div class="nav">
      <!-- REFACTOR HOW TO DISPLAY NAV BASED ON MODE, THE FOLLOWING IS A BIT CONFUSING AND RUSHED!! -->
      <viewNav :view="view" @viewSelected="changeView" v-if="mode >= 3" />
      <inputFilterNav @inputFilter="onNavInputFilter" />
      <displayNav
        :displayMode="displayMode"
        @displaySelected="changeDisplay"
        v-if="view === 'artist'"
      />
      <artistGroupsNav
        :artistGroupMode="artistGroupMode"
        :mode="mode"
        @artistGroupModeSelected="changeArtistGroupMode"
        v-if="mode > 0 && view === 'artist'"
      />
      <azNav
        :artistsAz="artistsAz"
        @azSelected="changeAz"
        v-if="
          (artistGroupMode === 'byAz' || artistGroupMode === 'byHeadliner') &&
          view === 'artist'
        "
      />
      <showGroupsNav
        :showGroupMode="showGroupMode"
        :view="view"
        @showGroupModeSelected="changeShowGroupMode"
        v-if="view === 'schedule'"
      />
      <showDaysNav
        :days="days"
        :activeDay="activeDay"
        @activeDaySelected="changeActiveDay"
        v-if="artistGroupMode === 'byDay' || view === 'schedule'"
      />
    </div>
    <!-- ARTIST/SCHEDULE COMPONENTS -->
    <div
      class="artistGrid"
      v-if="
        displayMode === 'grid' && view === 'artist' && artistsGrouping.length
      "
    >
      <div v-for="artist in artistsGrouping" :key="artist.id">
        <artistTile :artist="artist" />
      </div>
    </div>
    <div class="artistList" v-if="displayMode === 'list' && view === 'artist'">
      <div v-for="artist in artistsGrouping" :key="artist.id">
        <artistList :artist="artist" />
      </div>
    </div>
    <div v-if="displayMode === 'list' && view === 'schedule'">
      <div v-for="showgroup in scheduleGrouping" :key="showgroup.group">
        <div class="showGrouping">{{ showgroup.group }}</div>
        <div v-for="show in showgroup.shows" :key="show._id">
          <div class="scheduleList">
            <showList :show="show" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import artistTile from "./components/artistTile.vue";
//import showTile from './components/showTile.vue';
import artistList from "./components/artistList.vue";
import showList from "./components/showList.vue";
import { debounce } from "./helpers";
import wwParser from "./wwParser";
import inputFilterNav from "./components/nav/inputFilterNav";
import viewNav from "./components/nav/viewNav";
import displayNav from "./components/nav/displayNav";
import showDaysNav from "./components/nav/showDaysNav";
import showGroupsNav from "./components/nav/showGroupsNav";
import artistGroupsNav from "./components/nav/artistGroupsNav";
import azNav from "./components/nav/azNav";
export default {
  name: "app",
  props: {
    appId: String,
    dataPath: String,
  },
  components: {
    artistTile,
    artistList,
    //showTile,
    showList,
    inputFilterNav,
    viewNav,
    displayNav,
    showDaysNav,
    showGroupsNav,
    artistGroupsNav,
    azNav,
  },
  data() {
    return {
      // thee array of performing artists
      artists: [],
      sortedArtists: [],
      // model to represent array of artists on each day
      artistsByDay: {},
      // model to represent array of shows on each day by place
      showsByDayPlace: {},
      // model to represent array of shows on each day by time
      showsByDayTime: {},
      // an array of festival days - expected format YYYY-MM-DD
      days: [],
      // the active day selection for the festival
      activeDay: "",
      // default state for display mode - nav choice can be 'grid' or 'list'
      displayMode: "",
      // default state for view  - nav choice can be 'schedule' or 'artist'
      view: "",
      // default state for group mode - filter valid only for schedule - can be 'byPlace' or 'byTime'
      showGroupMode: "",
      // watcher for the input element
      inputFilter: "",
      // the 'debounced' input value
      debouncedInput: "",
      // wwParser class
      wwp: new wwParser(this.dataPath),
      // helper for computer props to tell if component is fully mounted/initialied
      mounted: false,
      // the mode enables/disables navigation elements
      mode: 0,
      // first letters of each artist
      artistsAz: [],
      // filters artists tab, byAz or byTime
      artistGroupMode: "",
    };
  },
  watch: {
    inputFilter: debounce(function (newVal) {
      this.debouncedInput = newVal;
    }, 300),
    artists: {
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.sortArtists(newVal);
        }
      },
      deep: true,
    },
  },
  async mounted() {
    await this.wwp.initialize();
    this.artists = this.wwp.artistsArr;
    this.sortArtists(this.artists);
    this.days = this.wwp.showsDays;
    this.artistsByDay = this.wwp.artistsByDay;
    this.showsByDayPlace = this.wwp.showsByDayPlace;
    this.showsByDayTime = this.wwp.showsByDayTime;
    this.activeDay = this.days ? this.days[0] : "";
    if (this.artistGroupMode === "byDay") {
      this.setArtistsByDay(this.activeDay);
    }
    this.mounted = true;
    this.mode = this.wwp.mode;
    this.artistsAz = this.wwp.artistsAz;
    // set up the default view
    this.changeView("artist");
    this.changeDisplay("grid");
    this.changeShowGroupMode("byTime");
    this.changeArtistGroupMode("byHeadliner");
  },
  computed: {
    artistsGrouping() {
      if (!this.mounted) {
        return;
      }
      return this?.sortedArtists?.filter((artist) => {
        let cleanTitle = artist?.title
          ?.trim()
          .toLowerCase()
          .includes(this.debouncedInput.toLowerCase());
        return cleanTitle;
      });
    },
    scheduleGrouping() {
      if (!this.mounted) {
        return;
      }
      let groups = undefined;
      if (this.showGroupMode === "byTime") {
        groups = this.showsByDayTime[this.activeDay].map((show) => {
          return {
            group: show.time_start,
            shows: show.shows.filter((show) => {
              if (!show.artist) {
                return false;
              }
              return show.artist?.title
                ?.toLowerCase()
                .includes(this.debouncedInput.toLowerCase());
            }),
          };
        });
      } else if (this.showGroupMode === "byPlace") {
        groups = this.showsByDayPlace[this.activeDay].map((shows) => {
          return {
            group: `STAGE: ${shows.venue}`,
            shows: shows.shows.filter((show) => {
              if (!show.artist) {
                return false;
              }
              return show?.artist?.title
                ?.toLowerCase()
                .includes(this.debouncedInput.toLowerCase());
            }),
          };
        });
      }
      return groups;
    },
  },
  methods: {
    sortArtists(arr) {
      // Don't re-sort here - preserve the order from the selected mode (billing order or alphabetical)
      this.sortedArtists = arr;
    },
    onNavInputFilter(filterStr) {
      this.debouncedInput = filterStr;
      this.$ga.event({
        eventCategory: "nav",
        eventAction: this.view,
        eventLabel: filterStr,
      });
    },
    changeView(view) {
      this.view = view;
      if (this.view === "schedule") {
        this.displayMode = "list"; // temporarily there is no grid schedule
      }
      this.$ga.event({
        eventCategory: "nav",
        eventAction: "view",
        eventLabel: view,
      });
    },
    changeDisplay(displayMode) {
      this.displayMode = displayMode;
      this.$ga.event({
        eventCategory: "nav",
        eventAction: this.view,
        eventLabel: displayMode,
      });
    },
    changeActiveDay(day) {
      this.activeDay = day;
      this.setArtistsByDay(day);
      this.$ga.event({
        eventCategory: "nav",
        eventAction: this.view,
        eventLabel: day,
      });
    },
    changeShowGroupMode(showGroupMode) {
      this.showGroupMode = showGroupMode;
      this.$ga.event({
        eventCategory: "nav",
        eventAction: this.view,
        eventLabel: showGroupMode,
      });
    },
    changeAz(alpha) {
      const els = document.querySelectorAll(`[data-letter='${alpha}']`);
      els[0].scrollIntoView(true);
      this.$ga.event({
        eventCategory: "nav",
        eventAction: this.view,
        eventLabel: alpha,
      });
    },
    changeArtistGroupMode(mode) {
      this.artistGroupMode = mode;
      if (this.artistGroupMode === "byDay") {
        this.setArtistsByDay(this.activeDay);
        if (this.view === "schedule") {
          // temporarily there is no grid schedule
          this.displayMode = "list";
        }
      } else if (this.artistGroupMode === "byAz") {
        this.setArtistsByAz();
        this.displayMode = "grid";
      } else if (this.artistGroupMode === "byHeadliner") {
        this.setArtistsByHeadliner();
        this.displayMode = "grid";
      }
      this.$ga.event({
        eventCategory: "nav",
        eventAction: this.view,
        eventLabel: mode,
      });
    },
    setArtistsByDay(day) {
      if (this.artistsByDay[day]) {
        this.artists = this.artistsByDay[day];
      } else {
        this.artists = [
          {
            id: "error",
            title: "No byDay data",
            photo:
              "https://storage.cloud.google.com/cms-org.media.aegpresents.com/misc/sadpanda.jpg",
          },
        ];
      }
    },
    setArtistsByAz() {
      this.artists = this.wwp.artistsAlphabetical;
    },
    setArtistsByHeadliner() {
      this.artists = this.wwp.artistsArr;
    },
  },
};
</script>
